import { render, staticRenderFns } from "./LegacyChartReferralScore.vue?vue&type=template&id=582ddcd4&"
import script from "./LegacyChartReferralScore.vue?vue&type=script&lang=ts&"
export * from "./LegacyChartReferralScore.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports